import { useState } from 'react';
import { Link } from 'react-router-dom';

const heroImages = [
  {
    src: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20movie%20collage%20with%20dramatic%20lighting%2C%20warm%20golden%20and%20deep%20crimson%20tones%2C%20film%20reel%20texture%20overlay%2C%20Chinese%20cinema%20atmosphere%2C%20grand%20theatrical%20composition%2C%20dark%20ambient%20background%20with%20spotlight%20effects&width=1920&height=700&seq=hero-slide-01&orientation=landscape',
    title: '流浪地球3',
    description: '太阳即将毁灭，人类的命运将何去何从？',
    link: '/article/1',
    badge: '正在热映',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Dramatic%20Chinese%20TV%20drama%20scene%20collage%20with%20ancient%20palace%20and%20modern%20city%20contrast%2C%20warm%20amber%20and%20deep%20red%20lighting%2C%20cinematic%20television%20production%20feel%2C%20intense%20character%20close-ups%2C%20grand%20scale&width=1920&height=700&seq=hero-slide-02&orientation=landscape',
    title: '狂飙',
    description: '二十年正邪较量，正义终将到来',
    link: '/article/7',
    badge: '热播推荐',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Music%20variety%20show%20stage%20with%20dramatic%20concert%20lighting%2C%20singers%20performing%2C%20massive%20LED%20screens%2C%20golden%20spotlights%2C%20grand%20live%20show%20atmosphere%2C%20warm%20theatrical%20glow%2C%20Chinese%20entertainment%20show&width=1920&height=700&seq=hero-slide-03&orientation=landscape',
    title: '歌手2026',
    description: '华语乐坛巅峰对决，谁将问鼎歌王？',
    link: '/article/14',
    badge: '热播综艺',
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {heroImages.map((img, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={img.src}
            alt={img.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60"></div>
        </div>
      ))}

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
          <div className="max-w-2xl">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-500/90 text-white text-xs font-medium mb-4 whitespace-nowrap">
              {heroImages[current].badge}
            </span>
            <h1 className="text-3xl md:text-5xl font-bold font-heading text-white mb-3 leading-tight">
              {heroImages[current].title}
            </h1>
            <p className="text-base md:text-lg text-white/80 mb-6">
              {heroImages[current].description}
            </p>
            <Link
              to={heroImages[current].link}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-play-fill"></i>
              </span>
              立即观看
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex items-center gap-2">
        {heroImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              index === current
                ? 'bg-primary-500 w-6'
                : 'bg-white/50 hover:bg-white/80'
            }`}
            aria-label={`切换到第${index + 1}张`}
          />
        ))}
      </div>

      <div className="absolute bottom-6 right-4 md:right-8 flex items-center gap-2">
        <button
          onClick={() => setCurrent((prev) => (prev === 0 ? heroImages.length - 1 : prev - 1))}
          className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 transition-colors cursor-pointer"
          aria-label="上一张"
        >
          <i className="ri-arrow-left-s-line text-white text-lg"></i>
        </button>
        <button
          onClick={() => setCurrent((prev) => (prev === heroImages.length - 1 ? 0 : prev + 1))}
          className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 transition-colors cursor-pointer"
          aria-label="下一张"
        >
          <i className="ri-arrow-right-s-line text-white text-lg"></i>
        </button>
      </div>
    </section>
  );
}